(async () => {
    console.log('fsr js')

    const hide_elements = (elements) => {
        elements.forEach(element => element.style.display = 'none')
    }

    const show_elements = (elements) => {
        elements.forEach(element => element.style.display = '')
    }

    const init = () => {
        console.log('FSR JS DOMContentLoaded')
        let fsr_all_options = document.querySelectorAll('.product_grid_item_intern .fsr-abo-selector-option')
        fsr_all_options.forEach(fsr_all_option => {
            fsr_all_option.addEventListener('click', () => {
                console.log('FSR Option Click')
                let sibling_options = fsr_all_option.parentElement.querySelectorAll('.fsr-abo-selector-option')
                sibling_options.forEach(option => {
                    if(option == fsr_all_option){
                        option.classList.add('fsr-active')
                    }else{
                        option.classList.remove('fsr-active')
                    }
                })

                let product_grid_item_intern = fsr_all_option.closest('.product_grid_item_intern')
                let visibility_selector = '.normal-price:not([data-variant-price])'
                if(product_grid_item_intern){
                    let toggle_vivibility = product_grid_item_intern.querySelectorAll(visibility_selector)
                    toggle_vivibility.forEach(element => {
                        if(fsr_all_option.id == 'fsr_single_time_button'){
                            element.style.opacity = '0'
                            setTimeout(() => {
                                element.style.visibility = 'hidden'
                            }, 100);
                        }else{
                            element.style.visibility = 'visible'
                            setTimeout(() => {
                                element.style.opacity = '1'
                            }, 10);
                        }
                    })
                }

                let display_abo_selector = 'div:has(>clever-select), .fsr-delivery-abo'
                let display_einmalkauf_selector = '.fsr-delivery-einmalkauf'

                if(fsr_all_option.id == 'fsr_single_time_button'){
                    let hide_these_elements = product_grid_item_intern.querySelectorAll(display_abo_selector)
                    let show_these_elements = product_grid_item_intern.querySelectorAll(display_einmalkauf_selector)

                    hide_elements(hide_these_elements)
                    show_elements(show_these_elements)
                }else{
                    let show_these_elements = product_grid_item_intern.querySelectorAll(display_abo_selector)
                    let hide_these_elements = product_grid_item_intern.querySelectorAll(display_einmalkauf_selector)

                    hide_elements(hide_these_elements)
                    show_elements(show_these_elements)
                }

                let event_id = product_grid_item_intern.querySelector('.fsr-abo-selector').dataset.event

                if(fsr_all_option.id == 'fsr_single_time_button'){
                    window.dispatchEvent(new CustomEvent(event_id, {detail:{currentABO : 'single'}})); 
                }else{
                    var currentABO = document.querySelectorAll(`[name="selling_plan_select_${event_id}"]:checked, [name="selling_plan_select_${event_id}"] > option[selected]`)[0]?.value;
                    window.dispatchEvent(new CustomEvent(event_id, {detail:{currentABO : ''}})); 
                }
            })

            if(fsr_all_option.id == 'fsr_single_time_button'){
                let product_grid_item_intern = fsr_all_option.closest('.product_grid_item_intern')
                let visibility_selector = '.normal-price:not([data-variant-price])'
                let display_abo_selector = 'div:has(>clever-select), .fsr-delivery-abo'
                let display_einmalkauf_selector = '.fsr-delivery-einmalkauf'
                if(product_grid_item_intern){
                    let hide_these_elements = product_grid_item_intern.querySelectorAll(display_abo_selector)
                    let show_these_elements = product_grid_item_intern.querySelectorAll(display_einmalkauf_selector)

                    hide_elements(hide_these_elements)
                    show_elements(show_these_elements)
                    let toggle_vivibility = product_grid_item_intern.querySelectorAll(visibility_selector)
                    toggle_vivibility.forEach(element => {
                        if(fsr_all_option.id == 'fsr_single_time_button'){
                            element.style.opacity = '0'
                            setTimeout(() => {
                                element.style.visibility = 'hidden'
                            }, 100);
                        }else{
                            element.style.visibility = 'visible'
                            setTimeout(() => {
                                element.style.opacity = '1'
                            }, 10);
                        }
                    })
                }

                let event_id = product_grid_item_intern.querySelector('.fsr-abo-selector').dataset.event
                window.dispatchEvent(new CustomEvent(event_id, {detail:{currentABO : 'single'}})); 
            }
        })
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            init()
        })
    }else{
        init()
    }

    window.addEventListener('pageshow', event => {
        if (event.persisted) init()
    })
})()